import React from "react";
import { Fade } from "react-reveal";

const Loan = () => {
  return (
    <svg
      width="22"
      height="14"
      viewBox="0 0 22 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1352 13.546C7.99801 13.546 4.86078 13.546 1.72356 13.546C0.799765 13.546 0.359524 13.1156 0.359014 12.2049C0.356467 8.77926 0.355957 5.35363 0.355957 1.92801C0.355957 1.05639 0.811484 0.608154 1.694 0.608154C7.99393 0.608154 14.2939 0.608154 20.5938 0.608154C21.4753 0.608154 21.9216 1.05588 21.9216 1.9351C21.9216 5.31865 21.9216 8.70219 21.9216 12.0852C21.9216 12.1613 21.9216 12.2373 21.9206 12.3129C21.9074 13.075 21.4422 13.54 20.6743 13.544C19.6058 13.5496 18.5378 13.5455 17.4693 13.5455C15.3583 13.5455 13.2468 13.5455 11.1357 13.5455L11.1352 13.546ZM13.8195 11.2603C13.9173 11.2684 13.9479 11.2729 13.979 11.2729C15.1652 11.2729 16.3519 11.277 17.5381 11.2658C17.6252 11.2648 17.7485 11.173 17.7923 11.0909C18.1786 10.3684 18.7258 9.81111 19.4626 9.44756C19.6104 9.37454 19.643 9.28581 19.6425 9.1342C19.6369 7.75959 19.6369 6.38497 19.6425 5.01036C19.643 4.85825 19.6068 4.77053 19.4601 4.69802C18.7233 4.33396 18.1694 3.77874 17.8036 3.04605C17.7343 2.90712 17.6466 2.8772 17.506 2.87771C16.3702 2.88177 15.235 2.88024 14.0992 2.88024C14.0279 2.88024 13.956 2.88024 13.8847 2.88024C15.3048 3.93998 16.1042 5.30952 16.1048 7.07051C16.1048 8.832 15.319 10.2091 13.8195 11.2598V11.2603ZM8.45048 2.88075C7.16899 2.88075 5.94915 2.87771 4.72932 2.88785C4.64881 2.88836 4.53519 2.97709 4.49391 3.05467C4.11023 3.77874 3.5635 4.337 2.82722 4.70258C2.68302 4.77408 2.64022 4.85774 2.64123 5.01239C2.64735 6.38751 2.64684 7.76263 2.64123 9.13775C2.64072 9.29037 2.67792 9.37758 2.82416 9.44958C3.55229 9.8106 4.10259 10.3587 4.46946 11.0803C4.54793 11.2344 4.64015 11.275 4.8032 11.2734C5.93896 11.2658 7.07472 11.2679 8.21099 11.2658C8.27265 11.2658 8.3343 11.2547 8.42245 11.2456C5.48191 9.28936 5.36981 4.9343 8.45048 2.87974V2.88075ZM14.2404 7.09484C14.2587 5.42716 12.8778 4.0206 11.1984 3.99728C9.48688 3.97344 8.06221 5.34704 8.0459 7.03704C8.0296 8.76101 9.41503 10.1508 11.1653 10.1645C12.8172 10.1777 14.222 8.77571 14.2404 7.09535V7.09484Z"
        fill="#E21F27"
      />
    </svg>
  );
};

const Repayment = () => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_843_3512)">
        <g clip-path="url(#clip1_843_3512)">
          <path
            d="M3.12497 20.3251C2.32691 19.5294 1.639 18.8423 0.894043 18.099C5.83536 13.1576 10.7997 8.19414 15.7996 3.19417H12.032V0.204816C12.1572 0.198476 12.2951 0.185796 12.433 0.185796C14.7147 0.184211 16.9971 0.183419 19.2787 0.185796C20.3986 0.186589 20.9977 0.777803 20.9993 1.88732C21.0025 4.18244 21.0001 6.47755 21.0001 8.77267V9.15308H18.0194V5.43144C13.0314 10.4203 8.06945 15.3822 3.12576 20.3251H3.12497Z"
            fill="#E21F27"
          />
          <path
            d="M8.99741 4.69994C8.99266 7.18526 6.96938 9.19349 4.47851 9.18319C2.01142 9.17368 0.0071513 7.16387 1.86839e-05 4.6944C-0.00711393 2.21859 2.02885 0.181038 4.50466 0.184208C6.98919 0.18817 9.00217 2.20987 8.99741 4.69915V4.69994ZM5.99458 4.69994C5.99934 3.8686 5.32808 3.18545 4.50387 3.18228C3.68758 3.17991 2.99255 3.87732 2.9973 4.6936C3.00206 5.50434 3.66697 6.17085 4.47851 6.17957C5.32174 6.18828 5.98904 5.53684 5.99458 4.69915V4.69994Z"
            fill="#E21F27"
          />
          <path
            d="M16.4896 12.186C18.9765 12.1844 21.0006 14.2046 20.9974 16.6859C20.9942 19.1633 18.9488 21.2009 16.4809 21.185C14.0066 21.1692 12.0024 19.1625 12 16.6978C11.9976 14.2006 14.0003 12.1884 16.4888 12.186H16.4896ZM16.5157 15.1889C15.6725 15.1809 15.0068 15.8324 15.0028 16.6708C14.9989 17.5022 15.6717 18.1861 16.4951 18.1869C17.294 18.1869 17.9779 17.5173 18.0001 16.7121C18.0223 15.8942 17.3431 15.1968 16.5157 15.1889Z"
            fill="#E21F27"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_843_3512">
          <rect
            width="21"
            height="21"
            fill="white"
            transform="translate(0 0.184204)"
          />
        </clipPath>
        <clipPath id="clip1_843_3512">
          <rect
            width="21"
            height="21"
            fill="white"
            transform="translate(0 0.184204)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const IntRate = () => {
  return (
    <svg
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.1475 5.00304C22.9669 6.18459 21.7756 7.37755 20.5806 8.57351C23.7546 12.7888 22.9357 18.3744 19.6272 21.6474C16.3162 24.9228 10.8262 25.6855 6.58165 22.508C6.50715 22.5777 6.42664 22.6481 6.35095 22.7238C5.01059 24.0562 3.66963 25.3886 2.33047 26.7222C1.93035 27.1206 1.46714 27.2919 0.911413 27.1152C-0.0204082 26.8183 -0.309387 25.6488 0.38212 24.9216C0.960678 24.3128 1.55906 23.7226 2.15625 23.1319C2.98713 22.3091 3.82523 21.4936 4.67295 20.663C2.85917 18.1935 2.22594 15.4957 2.82132 12.5442C3.25208 10.4107 4.31908 8.62099 5.9334 7.16119C9.2161 4.19291 14.5024 3.57029 18.559 6.61249C19.7605 5.41051 20.9585 4.21154 22.1408 3.0288C21.9137 3.0288 21.6326 3.0318 21.3514 3.02819C21.003 3.02399 20.6461 3.06125 20.309 2.99694C19.6932 2.87915 19.2913 2.31001 19.3105 1.67777C19.3292 1.05455 19.7749 0.497433 20.3896 0.418103C20.9333 0.347787 21.4854 0.344782 22.0345 0.320743C23.173 0.272063 24.3121 0.222782 25.4512 0.18552C26.4299 0.153668 27.0361 0.769681 26.9988 1.74629C26.9387 3.3353 26.8751 4.92431 26.8108 6.51333C26.7801 7.27177 26.1962 7.8325 25.4518 7.82408C24.7152 7.81567 24.1517 7.2285 24.1481 6.46344C24.1457 5.96643 24.1481 5.46941 24.1481 5.00304H24.1475ZM9.32665 18.7909C9.79346 18.7981 10.0614 18.6473 10.2975 18.4093C11.3327 17.3654 12.3714 16.3263 13.409 15.2841C14.4321 14.2565 15.4583 13.2324 16.4742 12.1981C16.9086 11.7557 16.8936 11.1307 16.4652 10.6944C16.0633 10.2845 15.4595 10.2707 15.0071 10.6656C14.8791 10.7773 14.762 10.9011 14.6418 11.0213C12.6694 12.9944 10.6964 14.9668 8.72526 16.9411C8.36539 17.3017 8.26686 17.7308 8.4555 18.1436C8.64836 18.5655 8.99201 18.7711 9.32665 18.7915V18.7909ZM11.2095 11.6578C11.2065 10.8074 10.5366 10.1379 9.68712 10.1355C8.82319 10.1331 8.1443 10.8104 8.1473 11.6722C8.1503 12.5148 8.8304 13.1963 9.6715 13.1999C10.5276 13.2041 11.2125 12.5172 11.2095 11.6578ZM17.0323 17.4778C17.0269 16.6159 16.3444 15.9512 15.4751 15.9609C14.6358 15.9705 13.9629 16.6604 13.9695 17.5048C13.9761 18.3462 14.6598 19.0241 15.5027 19.0241C16.3637 19.0241 17.0384 18.3426 17.0329 17.4772L17.0323 17.4778Z"
        fill="#E21F27"
      />
    </svg>
  );
};
const Guarantor = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_843_3526)">
        <g clip-path="url(#clip1_843_3526)">
          <path
            d="M12.8372 0.184192C19.9271 0.189101 25.6824 5.89133 25.6657 12.895C25.6483 19.8993 19.9023 25.5721 12.8285 25.5672C5.74047 25.5629 -0.0173335 19.857 3.921e-05 12.8557C0.0174119 5.85206 5.76404 0.179283 12.8372 0.184192ZM3.66319 12.8668C3.65823 17.8566 7.7619 21.9304 12.8087 21.9451C17.8666 21.9598 21.9976 17.8885 22.0032 12.8846C22.0087 7.89352 17.9063 3.82164 12.8577 3.80692C7.80161 3.79219 3.66816 7.86468 3.66319 12.8668Z"
            fill="#E21F27"
          />
          <path
            d="M10.9962 11.0677C10.9962 10.4658 10.982 9.8632 10.9993 9.26125C11.0279 8.27396 11.6967 7.55236 12.6628 7.44069C13.5109 7.34251 14.3529 7.9058 14.5874 8.7495C14.647 8.96243 14.665 9.19191 14.6675 9.41465C14.6768 10.2307 14.66 11.0475 14.6805 11.8635C14.6848 12.0237 14.7736 12.217 14.8877 12.3323C15.8476 13.3025 16.8316 14.2492 17.7896 15.2212C18.7184 16.1643 18.4156 17.6946 17.2113 18.1597C16.4872 18.4389 15.7923 18.3414 15.2296 17.7983C13.975 16.5859 12.7422 15.3513 11.5056 14.121C11.1365 13.7535 10.9956 13.292 10.9956 12.7827C10.9956 12.2115 10.9956 11.6396 10.9956 11.0683H10.9969L10.9962 11.0677Z"
            fill="#E21F27"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_843_3526">
          <rect
            width="25.6656"
            height="25.3836"
            fill="white"
            transform="translate(0 0.184204)"
          />
        </clipPath>
        <clipPath id="clip1_843_3526">
          <rect
            width="25.6656"
            height="25.3836"
            fill="white"
            transform="translate(0 0.184204)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const Disburse = () => {
  return (
    <svg
      width="23"
      height="29"
      viewBox="0 0 23 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_843_3535)">
        <path
          d="M15.6765 17.3944C16.3061 16.8582 16.8668 16.7311 17.5889 17.1829C18.4316 17.7106 19.3637 18.1005 20.258 18.547C20.9834 18.9102 21.3838 19.487 21.5107 20.2882C21.9165 22.8487 22.3427 25.4049 22.7581 27.9633C22.7882 28.1503 22.7925 28.3404 22.813 28.5658H0C0.11731 27.8009 0.228162 27.0564 0.347625 26.3129C0.666191 24.3325 0.997672 22.3531 1.30655 20.3715C1.44323 19.4956 1.87265 18.8718 2.69597 18.4893C3.58602 18.0759 4.48899 17.6689 5.31769 17.1509C6.03446 16.7033 6.5715 16.8945 7.16882 17.3901C6.76415 17.8559 6.36056 18.3206 5.93975 18.8045C5.98388 18.86 6.01509 18.9241 6.06675 18.9626C7.60577 20.1205 9.30407 20.9804 11.1326 21.585C11.2768 21.6331 11.4608 21.6566 11.6018 21.6117C13.524 21.005 15.2869 20.0938 16.9367 18.8451C16.5041 18.3451 16.0994 17.8783 15.6786 17.3923L15.6765 17.3944Z"
          fill="#E21F27"
        />
        <path
          d="M18.4379 15.3199H13.6519C13.6519 14.851 13.6325 14.3778 13.6648 13.9078C13.6734 13.786 13.8209 13.6461 13.9393 13.5627C15.1554 12.7092 15.7344 11.5235 15.7915 10.0707C15.8151 9.45118 15.7958 8.82948 15.7958 8.31888C14.8218 7.8478 13.9167 7.4109 12.9523 6.94409C11.3401 8.33597 9.28991 8.4524 7.15466 8.21099C6.83394 10.4115 7.07824 12.3215 8.9509 13.6044C9.06713 13.6834 9.20274 13.8287 9.21135 13.9516C9.24256 14.3895 9.22318 14.8318 9.22318 15.3071H4.39519C4.39519 15.1416 4.39519 14.9728 4.39519 14.8029C4.39519 12.4037 4.39088 10.0056 4.39626 7.60638C4.40595 3.99368 7.08362 0.950345 10.5491 0.607448C14.3568 0.230369 17.5942 2.57723 18.3303 6.25936C18.4099 6.65781 18.453 7.07014 18.4551 7.47713C18.467 9.98209 18.4616 12.4881 18.4605 14.9931C18.4605 15.0796 18.4487 15.1672 18.4379 15.3199Z"
          fill="#E21F27"
        />
        <path
          d="M11.4104 19.7146C10.3535 19.7231 9.46347 19.3396 8.74024 18.5769C8.49163 18.3141 8.29576 18.0086 8.62078 17.6989C8.9458 17.3891 9.21809 17.5867 9.48177 17.8623C10.5828 19.0106 12.2703 19.0042 13.3724 17.8484C13.6231 17.5856 13.8825 17.4126 14.1968 17.6764C14.5465 17.9713 14.3776 18.2736 14.1236 18.546C13.3928 19.3322 12.4909 19.7253 11.4093 19.7135L11.4104 19.7146Z"
          fill="#E21F27"
        />
      </g>
      <defs>
        <clipPath id="clip0_843_3535">
          <rect
            width="22.813"
            height="27.998"
            fill="white"
            transform="translate(0 0.56781)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const HiddenCa = () => {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.00774 18.3814C1.00774 18.2406 1.00774 18.1097 1.00774 17.9788C1.00774 12.9227 1.00774 7.86655 1.00774 2.80981C1.00834 1.41178 1.81998 0.567031 3.16499 0.566413C3.79686 0.566413 4.42873 0.565178 5.0606 0.566413C6.3012 0.570118 7.14903 1.44018 7.15199 2.73077C7.15733 5.14583 7.15377 7.56089 7.15377 9.97595C7.15377 12.6275 7.15377 15.2791 7.15377 17.93V18.3549H8.43649V17.9702C8.43649 14.6406 8.43472 11.311 8.43768 7.98079C8.43828 6.93474 9.02268 6.12766 9.94883 5.89054C10.1096 5.84917 10.2805 5.83681 10.4472 5.83558C11.158 5.83002 11.8693 5.82879 12.5801 5.83434C13.7335 5.84299 14.5807 6.72108 14.5825 7.92028C14.5861 11.2702 14.5837 14.6208 14.5837 17.9708C14.5837 18.0918 14.5837 18.2135 14.5837 18.353H15.8801C15.8801 18.2357 15.8801 18.1171 15.8801 17.998C15.8801 15.9324 15.8795 13.8668 15.8801 11.8007C15.8807 10.4638 16.7024 9.61286 17.9934 9.60977C18.655 9.60853 19.3165 9.60668 19.978 9.60977C21.1795 9.61718 22.0196 10.4903 22.0237 11.7531C22.0303 13.8292 22.0255 15.9052 22.0255 17.9807C22.0255 18.1011 22.0255 18.2209 22.0255 18.3363C22.2421 18.3703 22.4296 18.3814 22.6064 18.4321C22.8757 18.5099 23.0223 18.7587 22.9962 19.044C22.9706 19.3194 22.7689 19.5257 22.4895 19.5553C22.3916 19.5658 22.2925 19.5627 22.1934 19.5627C15.0643 19.5627 7.93515 19.5627 0.806021 19.5627C0.697446 19.5627 0.587685 19.5658 0.48089 19.5522C0.207377 19.5164 0.0133673 19.2959 0.000314577 19.0162C-0.0139247 18.718 0.162286 18.4679 0.445885 18.4185C0.61913 18.3882 0.797714 18.3925 1.00774 18.3796V18.3814Z"
        fill="#E21F27"
      />
    </svg>
  );
};
export default function Freedom() {
  return (
    <div>
      <Fade bottom>
        <div className="gap-[25px] md:px-[115px] max-w-[1520px] mx-auto min-[616px] px-[1rem] md:py-[4.6rem] py-[2rem]">
          <div className="md:flex justify-center items-center gap-[20px]">
            <div className="md:flex-1 flex justify-center items-center">
              <div className="h-[578px] w-[267px] ">
                <img
                  src="/images/mock.png"
                  alt="Mock up"
                  className="border-4 border-[#3333334A] rounded-2xl h-full w-full object-cover overflow-hidden mx-auto"
                />
              </div>
            </div>
            <div className="flex-1">
              <div className="md:my-0 my-10">
                <h1 className="text-[#1E1E1E] font-extrabold md:text-[2.38rem] text-[1.8rem]">
                  Your ticket to Financial Freedom
                </h1>
                <p className="text-[#333333] font-normal text-justify md:text-[1rem] text-[1rem] my-[30px]">
                  The future of your dreams is closer than you think. Whatever
                  your destination is, we’re more than ready to help you reach
                  it.
                </p>
                <ul className="font-bold flex flex-col gap-5 text-[18px]">
                  <li className="flex items-center gap-8">
                    <span>
                      <Loan />
                    </span>
                    <span>N100,000 minimum investment.</span>
                  </li>
                  <li className="flex items-center gap-8">
                    <span>
                      <Repayment />
                    </span>
                    <span>Competitive Interest Rate</span>
                  </li>
                  <li className="flex items-center gap-8">
                    <span>
                      <IntRate />
                    </span>
                    <span>Flexible interest payment</span>
                  </li>
                  <li className="flex items-center gap-8">
                    <span>
                      <Guarantor />
                    </span>
                    <span>Easy access to funds</span>
                  </li>
                  <li className="flex items-center gap-8">
                    <span>
                      <Disburse />
                    </span>
                    <span>Hands-on Investment officer</span>
                  </li>
                  <li className="flex items-center gap-8">
                    <span>
                      <HiddenCa />
                    </span>{" "}
                    <span>Real-time portfolio monitoring</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}

